import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { FDBox } from '@facet-wealth/design';
import SyncingProgress from './SyncingProgress';
import { SYNC_STATUS_MAP, useYodleeLinkContext } from '../YodleeLinkContext';

import { YODLEE_FASTLINK_ELEMENT_ID } from '..';

const styles = theme => ({
  root: {},
  buttonComponent: {},
  syncProgressBar: {},
  initializing: {
    zIndex: -1,
    height: '60vh',
  },
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    backgroundColor: theme.palette.common.white,
    width: '100vw',
    height: '100dvh',
    zIndex: theme.zIndex.modal,
  },
  hidden: {
    display: 'none',
  },
});

const YodleeLinkContext = ({
  className,
  classes,
  resource,
  renderButtonComponentChildren,
  ButtonComponent,
  ButtonComponentProps,
}) => {
  const {
    handleClick,
    isInitialized,
    showConnectView,
    syncStatus,
  } = useYodleeLinkContext();

  return (
    <div className={classNames(classes.root, className)}>
      <ButtonComponent
        {...ButtonComponentProps}
        className={classes.buttonComponent}
        disabled={!isInitialized}
        onClick={handleClick}
      >
        {renderButtonComponentChildren(resource)}
      </ButtonComponent>
      <SyncingProgress
        className={classNames(classes.syncProgressBar, {
          [classes.hidden]: syncStatus !== SYNC_STATUS_MAP.working,
        })}
        message={'Syncing your account information...'}
      />
      <div
        className={classNames(classes.container, {
          [classes.hidden]: !showConnectView,
        })}
      >
        <FDBox paddingY={2} overflow="auto" height="100dvh">
          <div id={YODLEE_FASTLINK_ELEMENT_ID} />
        </FDBox>
      </div>
    </div>
  );
};

YodleeLinkContext.defaultProps = {
  className: '',
};

YodleeLinkContext.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  renderButtonComponentChildren: PropTypes.func.isRequired,
  ButtonComponent: PropTypes.object.isRequired,
  ButtonComponentProps: PropTypes.object.isRequired,
};

export default withStyles(styles)(YodleeLinkContext);
